import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { CusButton } from '../../Components/From/Button';
import { CusInput } from '../../Components/From/Input';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';
import Tool_dropDown from '../../Components/Tools/Tool_dropDown';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import { getAllCountry, getSpecificCountry } from '../../Api/GetCountry';
import { postCreateOrder } from '../../Api/GetOrder';

import Tool_storeName from '../Tools/Tool_storeName';
import moment from 'moment';

/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 * country
 * currentStep (2 ± 1)
 */

function StaffOrderStep_3(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    countryList: [],
    numberOfAdult: '',
    numberOfChild: '',
    countrySelected: {
      country: null,
      countryName: null
    }
  });
  // 取得所有國家
  async function apiAllCountry(langId) {
    try {
      const res = await getAllCountry(langId);
      const { errCode, countryList } = res.data;
      if (errCode == 200) {
        const newCountryList = countryList.map(e => ({
          title: e.name,
          value: e.id
        }));
        return newCountryList;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('AllCountry error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 406 }]
      });
      props.history.push('/staff/error');
    }
  }
  // 取得指定的國家
  async function apiSpecificCountry(requireData) {
    try {
      const res = await getSpecificCountry(requireData);
      const { errCode, country } = res.data;
      if (errCode == 200) {
        const newSelectedCountry = {
          title: country.name,
          value: country.id
        };
        return newSelectedCountry;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/staff/error');
      }
    } catch (err) {
      console.error('SpecificCountry error.');
    }
  }
  // get api
  useEffect(() => {
    const langCode = langStringToCode(globalState.langType);
    const countryCode = globalState.customer.orderInfo.country;
    const updateCountryList = async () => {
      let countryList = await apiAllCountry(langCode);
      if (countryList) {
        setState(curr => {
          let newState = { ...curr };
          newState.countryList = countryList;
          return newState;
        });
      }
    };
    updateCountryList();
  }, [globalState.langType]);

  // 更新globalState country
  useEffect(() => {
    const { country, countryName } = state.countrySelected;
    dispatchGlobal({
      type: 'UPDATE',
      payload: [
        {
          key: 'staffInfo',
          val: {
            ...globalState.staffInfo,
            takeOrderData: {
              ...globalState.staffInfo.takeOrderData,
              country: country ? country : null,
              countryName: countryName ? countryName : null
            }
          }
        }
      ]
    });
  }, [state.countrySelected]);

  function showForm() {
    let pcStyle = globalState.device === 'pc';
    return (
      <div className="d-flex col flex-column justify-content-center align-items-center p-0">
        <div
          className="d-flex flex-column pt-4 pb-4"
          style={{
            minWidth: pcStyle ? '500px' : '100%',
            maxWidth: pcStyle ? '500px' : '100%'
          }}
        >
          <div>
            <div className="w-100">
              <FormattedMessage id="pages.staffOrder.step3.numberOfTitle" />
            </div>
            <div className="d-flex w-100">
              <div className="d-flex col-4 p-0">
                <CusInput
                  className="w-100 text-center"
                  value={state.numberOfAdult}
                  type="tel"
                  maxLength={2}
                  placeholder={0}
                  onChange={event => {
                    let val = event.target.value;
                    setState(curr => {
                      let newState = { ...curr };
                      newState.numberOfAdult = Number(val);
                      return newState;
                    });
                  }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.staffOrder.step3.numberOfAdult" />
                </span>
              </div>
              <div className="d-flex col-4 p-0">
                <CusInput
                  className="w-100 text-center"
                  value={state.numberOfChild}
                  type="tel"
                  maxLength={2}
                  placeholder={0}
                  onChange={event => {
                    let val = event.target.value;
                    setState(curr => {
                      let newState = { ...curr };
                      newState.numberOfChild = Number(val);
                      return newState;
                    });
                  }}
                />
                <span className="text-nowrap d-flex align-items-center mr-2 ml-2">
                  <FormattedMessage id="pages.staffOrder.step3.numberOfChild" />
                </span>
              </div>
            </div>
          </div>
          <div className="mt-4 mb-4">
            <div className="w-100">
              <FormattedMessage id="pages.staffOrder.step3.countryOfbranch" />
            </div>
            <Tool_dropDown
              items={state.countryList}
              selected={state.countrySelected.country}
              onSelected={e => {
                setState(curr => {
                  let newState = { ...curr };
                  newState.countrySelected = {
                    country: e.value,
                    countryName: e.title
                  };
                  return newState;
                });
              }}
            />
          </div>
          <div className="mt-4 mb-4 d-flex">
            {/* 返回 */}
            <CusButton.White
              className="mt-2 mb-2 mr-3 col p-3"
              children={
                <FormattedMessage id="pages.staffTakeOrder.step3.buttonBack" />
              }
              onClick={() => {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [
                    {
                      key: 'staffInfo',
                      val: {
                        ...globalState.staffInfo,
                        currentTakeOrderStep: '2',
                      }
                    }
                  ]
                });
              }}
            />
            {/* 確認 */}
            <CusButton.Red
              className="mt-2 mb-2 ml-3 col p-3"
              children={
                <FormattedMessage id="pages.staffTakeOrder.step3.buttonConfirm" />
              }
              disabled={(!state.numberOfAdult && !state.numberOfChild) || !state.countrySelected.country}
              onClick={async () => {
                try {
                  let res = await postCreateOrder({
                    queueNumber: '',
                    queueCode: '',
                    countryID: state.countrySelected.country,
                    storeID: globalState.staffInfo.checkOrderBranch.branchCode,
                    adultsCount: state.numberOfAdult || 0,
                    childCount: state.numberOfChild || 0,
                    languageID: langStringToCode(globalState.langType),
                    userEmail: '',
                    dineIn: [],
                    takeout: [],
                    totalPrice: 0,
                    waiterID: globalState.staffInfo.checkOrderStaff.staffCode,
                    orderExtraList:[1]
                  });
                  const { orderCode } = res.data.order;
                  const { errCode } = res.data;
                  // AsyncModelClose();
                  if (errCode === 200) {
                    dispatchGlobal({
                      type: 'UPDATE',
                      payload: [
                        {
                          key: 'staffInfo',
                          val: {
                            ...globalState.staffInfo,
                            currentTakeOrderStep: '4',
                            orderCode,
                            takeOrderData: {
                              ...globalState.staffInfo.takeOrderData,
                              isNonQueueNumber: true,
                              numberOfAdult: state.numberOfAdult || 0,
                              numberOfChild: state.numberOfChild || 0,
                              orderTime: moment().format('YYYY/MM/DD HH:mm:ss')
                            }
                          }
                        }
                      ]
                    });
                  } else {
                    dispatchGlobal({
                      type: 'UPDATE',
                      payload: [{ key: 'errMsg', val: errCode }]
                    });
                    props.history.push('/staff/error');
                  }
                } catch (err) {
                  console.error('CreateOrder error.');
                  dispatchGlobal({
                    type: 'UPDATE',
                    payload: [{ key: 'errMsg', val: 409 }]
                  });
                  props.history.push('/staff/error');
                }
              }}
            />
          </div>
        </div>
      </div>
    );
  }
  // 接收到countryList資料之前 不渲染畫面
  if (
    !state.countryList ||
    (Array.isArray(state.countryList) && state.countryList.length <= 0)
  )
    return null;

  return (
    <>
      <div className="d-flex align-items-center justify-content-center txtColorBrown mb-3">
        <span className="m-2">
          <Tool_storeName storeId={globalState.staffInfo.checkOrderBranch.branchCode} />
          {/* {globalState.staffInfo.checkOrderBranch.branchName} */}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderGroup.groupName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffName}
        </span>
        <span className="m-2">
          {globalState.staffInfo.checkOrderStaff.staffNum}
        </span>
      </div>
      {showForm()}
    </>
  );
}

export default withRouter(StaffOrderStep_3);
